import { ComplextRoute } from 'router/components/Routes/Routes';
import { MarketYourListing } from './pages/MarketYourListing';
import EditDealRoom from './pages/EditDealRoom';

export default [
  {
    index: true,
    element: EditDealRoom,
  },
  {
    path: 'market-listing',
    element: MarketYourListing,
  },
] as Array<ComplextRoute>;
